<script>
    import Transition from "../components/Transition.svelte";
    import {onMount} from "svelte";
    import {productionsUrl, propsUrl, resourcesUrl} from "../urls";
    import {customFetch} from "../customFetch";
    import {notifications} from "../notifications";
    import StraightTable from "../components/StraightTable.svelte";

    import {
        dropdownView,
        dropdownArrayView,
        editableImageView,
        valueView,
        saveRows, labelView
    } from "../tableUtils";

    onMount(init);

    let originalRows = {};
    let rows = [];
    let productions = {}
    let resources = {}
    let resourcesWithEmpty = {None: "0"}
    let columns = [];

    async function loadResources() {
        let data = await customFetch(resourcesUrl());
        let resourcesJson = await data.json();
        for (let i = 0; i < resourcesJson.length; i++) {
            let resource = resourcesJson[i];
            resources[resource.Name] = resource.ID;
            resourcesWithEmpty[resource.Name] = resource.ID;
        }
    }

    async function loadProps() {
        let props = await customFetch(propsUrl());
        let propsJson = await props.json();
        for (let i = 0; i < propsJson.length; i++) {
            let prop = propsJson[i];
            if (prop.InternalKey === "m-production") {
                productions[prop.Name] = prop.ID;
            }
        }
    }

    async function load() {
        try {
            let response = await customFetch(productionsUrl());
            let data = await response.json();
            for (let i = 0; i < data.length; i++) {
                data[i].UpdatedAt = new Date(data[i].UpdatedAt)
                data[i].Changes = new Set();
                originalRows[data[i].ID] = JSON.parse(JSON.stringify(data[i]));
            }
            rows = data;
            columns = [
                {title: 'ID', field: 'ID', sortable: true, defaultValue: null, editView: labelView},
                {title: 'Icon', field: 'NewIcon', sortable: false, defaultValue: null, editView: editableImageView()},
                {title: 'Name', field: 'Name', sortable: true, defaultValue: '', editView: valueView("text")},
                {title: 'Production', field: 'PropId', sortable: false, defaultValue: null, editView: dropdownView(productions)},
                {title: 'Incoming resources', field: 'IncomingResources', sortable: false, defaultValue: [], editView: dropdownArrayView(resources)},
                {title: 'Outgoing resources', field: 'OutgoingResources', sortable: false, defaultValue: [], editView: dropdownArrayView(resources)},
                {title: 'Booster resource', field: 'BoosterResource', sortable: false, defaultValue: "0", editView: dropdownView(resourcesWithEmpty)},
            ];
        } catch (e) {
            notifications.danger(
                `Error loading locomotives: ${e.message}`
            );
        }
    }

    async function init() {
        await loadProps();
        await loadResources();
        await load();
    }

    async function save(e) {
        const rows = e.detail.data;
        let fields = columns.map(elem => elem.field);
        await saveRows(rows, fields, productionsUrl());
        await load();
    }
</script>

<Transition>
    <StraightTable data={rows} {columns} on:change={save}/>
</Transition>
